window.locales = window.locales || {};window.locales.am = window.locales.am || {};window.locales.am.scholarship_labels = window.locales.am.scholarship_labels || {};window.locales.am.scholarship_labels = {...window.locales.am.scholarship_labels, ...{
    "entrepreneurship": "የ Hyperion ሽልማት ለኢንተርፕሪነሮች",           
    "entrepreneurship_desc": "ጉጉት ላላቸው እና ለወቅታዊ ኢንተርፕርነሮች የትምህርት ክፍያ እርዳታ የሚያደርግ ስኮላርሺፕ።",           
    "emerging_leaders": "Strada ስኮላርሺፕ ለአዳዲስ መሪዎች",           
    "emerging_leaders_desc": "ብዙ ጊዜ በታዳጊ ኢንዱስትሪ ወይም ሃገር ውስጥ የሚሰሩ ተስፋ ሰጪ የመሪነት ችሎታ ላላቸው ተማሪዎች ሽልማት ይሰጣል።",           
    "sustainability": "Powell Impact and Sustainability ስኮላርሺፕ",           
    "sustainability_desc": "የማህበረሰባቸውን ደህንነት ወይም የአለምን ሁኔታ ለማሻሻል ለሚሰሩ ሰዎች።",           
    "women_in_tech": "በቴክ ውስጥ ላሉ ሴቶች ያለ የመሪነት ሽልማት",           
    "women_in_tech_desc": "ልዩ የመሪነት ብቃቶች ላላቸው ንቁ የቴክኖሎጂ ባለሙያዎች እና አስፈጻሚዎች ሽልማት ይሰጣል።",           
    "academic_excellence": "ለአካዳሚክ ልህቀት የ Zenith ሽልማት",           
    "academic_excellence_desc": "በጥናታቸው ውስጥ ሁሉ ልዩ የሆነ የአካዳሚክ ብቃታቸውን ላሳዩ ሰዎች የሚሰጥ።",           
    "innovation_sponsorship_award": "የኢኖቬሽን ስፖንሰርሺፕ ሽልማት",
    "edcor_award": "የኤድኮር ሽልማት",
    "global_health_impact_network": "ዓለም አቀፍ የጤና ተጽዕኖ አውታረ መረብ",
    "employer_partner": "የአሰሪ አጋር ስኮላርሺፕ",
    "recruitment": "የቅጥር ስኮላርሺፕ",
    "strada": "የአመራር ስኮላርሺፕ",
    "impact_quantic": "የኳንቲክ ተፅእኖ ስኮላርሺፕ",
    "powell": "የክልል ስኮላርሺፕ",
    "impact_valar": "የቫላር ኢምፓክት ስኮላርሺፕ",
    "hyperion": "የክልል ስኮላርሺፕ",
    "base_scholarship": "ስኮላርሺፕ",
    "strada_application": "የአመራር ስኮላርሺፕ",
    "impact_quantic_application": "ተፅዕኖ ስኮላርሺፕ",
    "powell_application": "የገንዘብ እርዳታ ስኮላርሺፕ",
    "impact_valar_application": "ተፅዕኖ ስኮላርሺፕ",
    "employer_partner_application": "የአሰሪ አጋር ስኮላርሺፕ",
    "recruitment_application": "የቅጥር ስኮላርሺፕ",
    "hyperion_application": "የገንዘብ እርዳታ ስኮላርሺፕ",
    "exec_ed_launch": "Exec Ed ማስጀመሪያ ስኮላርሺፕ",
    "alumni_application": "የተመራቂ ተማሪዎች ስኮላርሺፕ",
    "zenith": "የአመራር ስኮላርሺፕ",
    "zenith_application": "የአመራር ስኮላርሺፕ",
    "alumni_quantic_launch": "የመጀመሪያ ቡድን ስኮላርሺፕ",
    "apex_quantic": "የኳንቲክ 2025 አፕክስ ስኮላርሺፕ",
    "apex_valar": "የቫላር 2025 አፕክስ ስኮላርሺፕ",
    "ai_launch_2026": "የ2026 AI ማስጀመሪያ ስኮላርሺፕ",
    "nexus_2025": "2025 Nexus ስኮላርሺፕ",
    "alumni": "{{offeredYear}} የቀድሞ ተማሪዎች ስኮላርሺፕ",
    "regional_application": "የክልል ስኮላርሺፕ"
}
};window.locales.ar = window.locales.ar || {};window.locales.ar.scholarship_labels = window.locales.ar.scholarship_labels || {};window.locales.ar.scholarship_labels = {...window.locales.ar.scholarship_labels, ...{
    "entrepreneurship": "جائزة هايبريون لرواد الأعمال",
    "emerging_leaders": "منحة سترادا للقادة الناشئين",
    "sustainability": "منحة باول للتأثير والاستدامة",
    "women_in_tech": "جائزة القيادة للمرأة في التكنولوجيا",
    "academic_excellence": "جائزة زينيث للتفوق الأكاديمي",
    "entrepreneurship_desc": "منحة دراسية تقدم المساعدة في الرسوم الدراسية لأصحاب المشاريع الطموحين والمتمرسين.",
    "sustainability_desc": "لأولئك الذين يعملون على تحسين رفاهية مجتمعهم أو حالة العالم.",
    "women_in_tech_desc": "تُمنح لمتخصصي التكنولوجيا النشطين والمديرين التنفيذيين الذين يتمتعون بصفات قيادية استثنائية.",
    "academic_excellence_desc": "تُمنح لأولئك الذين أظهروا أداءً أكاديميًا استثنائيًا خلال دراستهم.",
    "emerging_leaders_desc": "تُمنح للطلاب ذوي القدرات القيادية الواعدة ، الذين يعملون غالبًا في صناعة أو دولة ناشئة.",
    "innovation_sponsorship_award": "جائزة رعاية الابتكار",
    "edcor_award": "جائزة Edcor",
    "global_health_impact_network": "شبكة التأثير الصحي العالمية",
    "employer_partner": "منحة شريك صاحب العمل",
    "recruitment": "منحة التوظيف",
    "strada": "منحة القيادة",
    "impact_quantic": "منحة كوانتيك للتأثير",
    "powell": "منحة دراسية إقليمية",
    "impact_valar": "منحة فالار امباكت",
    "hyperion": "منحة دراسية إقليمية",
    "base_scholarship": "منحة دراسية",
    "strada_application": "منحة القيادة",
    "impact_quantic_application": "منحة التأثير",
    "powell_application": "منحة المساعدات المالية",
    "impact_valar_application": "منحة التأثير",
    "employer_partner_application": "منحة شريك صاحب العمل",
    "recruitment_application": "منحة التوظيف",
    "hyperion_application": "منحة المساعدات المالية",
    "exec_ed_launch": "منحة إطلاق Exec Ed",
    "alumni_application": "منحة الخريجين",
    "zenith": "منحة القيادة",
    "zenith_application": "منحة القيادة",
    "alumni_quantic_launch": "منحة الفوج الافتتاحي",
    "apex_quantic": "منحة كوانتيك 2025 ايبكس",
    "apex_valar": "منحة فالار 2025 ابيكس",
    "ai_launch_2026": "منحة إطلاق الذكاء الاصطناعي 2026",
    "nexus_2025": "منحة نيكسوس 2025",
    "alumni": "منحة الخريجين {{offeredYear}}",
    "regional_application": "منحة دراسية إقليمية"
}
};window.locales.en = window.locales.en || {};window.locales.en.scholarship_labels = window.locales.en.scholarship_labels || {};window.locales.en.scholarship_labels = {...window.locales.en.scholarship_labels, ...{
                                                                                       
    "employer_partner": "Employer Partner Scholarship",
    "recruitment": "Recruitment Scholarship",
    "strada": "Leadership Scholarship",
    "impact_quantic": "Quantic Impact Scholarship",
    "powell": "Regional Scholarship",
    "zenith": "Leadership Scholarship",
    "impact_valar": "Valar Impact Scholarship",
    "hyperion": "Regional Scholarship",
    "exec_ed_launch": "Exec Ed Launch Scholarship",
    "nexus_2025": "2025 Nexus Scholarship",
    "alumni": "{{offeredYear}} Alumni Scholarship",
    "alumni_quantic_launch": "Inaugural Cohort Scholarship",
    "apex_quantic": "Quantic 2025 Apex Scholarship",
    "apex_valar": "Valar 2025 Apex Scholarship",
    "ai_launch_2026": "2026 AI Launch Scholarship",

    "employer_partner_application": "Employer Partner Scholarship",
    "recruitment_application": "Recruitment Scholarship",
    "strada_application": "Leadership Scholarship",
    "impact_quantic_application": "Impact Scholarship",
    "powell_application": "Financial Aid Scholarship",
    "zenith_application": "Leadership Scholarship",
    "impact_valar_application": "Impact Scholarship",
    "hyperion_application": "Financial Aid Scholarship",
    "alumni_application": "Alumni Scholarship",
    "regional_application": "Regional Scholarship",

                                                
    "entrepreneurship": "Hyperion Award for Entrepreneurs",
    "entrepreneurship_desc": "Scholarship that provides tuition assistance for aspiring and seasoned entrepreneurs.",
    "emerging_leaders": "Strada Scholarship for Emerging Leaders",
    "emerging_leaders_desc": "Awarded to students with promising leadership ability, who often work in an emerging industry or nation.",
    "sustainability": "Powell Impact and Sustainability Scholarship",
    "sustainability_desc": "For those working to improve the wellbeing of their community or the state of the world.",
    "women_in_tech": "Leadership Award for Women in Tech",
    "women_in_tech_desc": "Awarded to active technology professionals and executives with exceptional leadership qualities.",
    "academic_excellence": "The Zenith Award for Academic Excellence",
    "academic_excellence_desc": "Given to those who have demonstrated exceptional academic performance throughout their studies.",

                                                                                                        
                                                                                                              
                                                                                                                
    "innovation_sponsorship_award": "Innovation Sponsorship Award",
    "edcor_award": "Edcor Award",
    "global_health_impact_network": "Global Health Impact Network",

    "base_scholarship": "Scholarship"
}
};window.locales.es = window.locales.es || {};window.locales.es.scholarship_labels = window.locales.es.scholarship_labels || {};window.locales.es.scholarship_labels = {...window.locales.es.scholarship_labels, ...{
    "entrepreneurship": "Premio Hyperion para emprendedores",
    "emerging_leaders": "Beca Strada para líderes emergentes",
    "sustainability": "Beca Powell de Impacto y Sostenibilidad",
    "women_in_tech": "Premio al liderazgo para mujeres en tecnología",
    "academic_excellence": "El premio Zenith a la excelencia académica",
    "entrepreneurship_desc": "Beca que brinda asistencia para la matrícula para emprendedores aspirantes y experimentados.",
    "sustainability_desc": "Para quienes trabajan para mejorar el bienestar de su comunidad o el estado del mundo.",
    "women_in_tech_desc": "Otorgado a profesionales y ejecutivos de tecnología activos con cualidades de liderazgo excepcionales.",
    "academic_excellence_desc": "Otorgado a quienes hayan demostrado un rendimiento académico excepcional a lo largo de sus estudios.",
    "emerging_leaders_desc": "Otorgado a estudiantes con una capacidad de liderazgo prometedora, que a menudo trabajan en una industria o nación emergente.",
    "innovation_sponsorship_award": "Premio Patrocinio Innovación",
    "edcor_award": "Premio Edcor",
    "global_health_impact_network": "Red Global de Impacto en la Salud",
    "employer_partner": "Beca Socio Empleador",
    "recruitment": "Beca de Reclutamiento",
    "strada": "Beca de Liderazgo",
    "impact_quantic": "Beca de impacto cuántico",
    "powell": "Beca regional",
    "impact_valar": "Beca de impacto Valar",
    "hyperion": "Beca regional",
    "base_scholarship": "Beca",
    "strada_application": "Beca de Liderazgo",
    "impact_quantic_application": "Beca de impacto",
    "powell_application": "Beca de ayuda financiera",
    "impact_valar_application": "Beca de impacto",
    "employer_partner_application": "Beca Socio Empleador",
    "recruitment_application": "Beca de Reclutamiento",
    "hyperion_application": "Beca de ayuda financiera",
    "exec_ed_launch": "Beca de lanzamiento de educación ejecutiva",
    "alumni_application": "Beca de antiguos alumnos",
    "zenith": "Beca de liderazgo",
    "zenith_application": "Beca de liderazgo",
    "alumni_quantic_launch": "Beca de cohorte inaugural",
    "apex_quantic": "Beca Apex Quantic 2025",
    "apex_valar": "Beca Apex Valar 2025",
    "ai_launch_2026": "Beca de lanzamiento de IA 2026",
    "nexus_2025": "Beca Nexus 2025",
    "alumni": "Beca para exalumnos {{offeredYear}}",
    "regional_application": "Beca regional"
}
};window.locales.it = window.locales.it || {};window.locales.it.scholarship_labels = window.locales.it.scholarship_labels || {};window.locales.it.scholarship_labels = {...window.locales.it.scholarship_labels, ...{
    "entrepreneurship": "Premio Hyperion per imprenditori",
    "emerging_leaders": "Borsa di studio Strada per leader emergenti",
    "sustainability": "Borsa di studio Powell Impact and Sustainability",
    "women_in_tech": "Premio Leadership per Women in Tech",
    "academic_excellence": "Il premio Zenith per l'eccellenza accademica",
    "entrepreneurship_desc": "Borsa di studio che fornisce assistenza didattica per aspiranti e stagionati imprenditori.",
    "sustainability_desc": "Per coloro che lavorano per migliorare il benessere della propria comunità o lo stato del mondo.",
    "women_in_tech_desc": "Conferito a professionisti e dirigenti tecnologici attivi con eccezionali qualità di leadership.",
    "academic_excellence_desc": "Dato a coloro che hanno dimostrato prestazioni accademiche eccezionali durante i loro studi.",
    "emerging_leaders_desc": "Assegnato a studenti con promettenti capacità di leadership, che spesso lavorano in un settore o nazione emergente.",
    "innovation_sponsorship_award": "Premio per la sponsorizzazione dell'innovazione",
    "edcor_award": "Premio Edcor",
    "global_health_impact_network": "Rete globale di impatto sulla salute",
    "employer_partner": "Borsa di studio per datori di lavoro",
    "recruitment": "Borsa di studio per il reclutamento",
    "strada": "Borsa di studio per la leadership",
    "impact_quantic": "Borsa di studio sull'impatto quantico",
    "powell": "Borsa di studio regionale",
    "impact_valar": "Borsa di studio Valar Impact",
    "hyperion": "Borsa di studio regionale",
    "base_scholarship": "Borsa di studio",
    "strada_application": "Borsa di studio per la leadership",
    "impact_quantic_application": "Borsa di studio sull'impatto",
    "powell_application": "Borsa di studio per aiuti finanziari",
    "impact_valar_application": "Borsa di studio sull'impatto",
    "employer_partner_application": "Borsa di studio per datori di lavoro",
    "recruitment_application": "Borsa di studio per il reclutamento",
    "hyperion_application": "Borsa di studio per aiuti finanziari",
    "exec_ed_launch": "Borsa di studio per il lancio di Exec Ed",
    "alumni_application": "Borsa di studio per ex studenti",
    "zenith": "Borsa di studio sulla leadership",
    "zenith_application": "Borsa di studio sulla leadership",
    "alumni_quantic_launch": "Borsa di studio della coorte inaugurale",
    "apex_quantic": "Borsa di studio Quantic 2025 Apex",
    "apex_valar": "Borsa di studio Valar 2025 Apex",
    "ai_launch_2026": "Borsa di studio lancio AI 2026",
    "nexus_2025": "Borsa di studio Nexus 2025",
    "alumni": "Borsa di studio per ex studenti {{offeredYear}}",
    "regional_application": "Borsa di studio regionale"
}
};window.locales.zh = window.locales.zh || {};window.locales.zh.scholarship_labels = window.locales.zh.scholarship_labels || {};window.locales.zh.scholarship_labels = {...window.locales.zh.scholarship_labels, ...{
    "entrepreneurship": "亥伯龙企业家奖",           
    "emerging_leaders": "斯特拉达新兴领袖奖学金",           
    "sustainability": "鲍威尔影响和可持续发展奖学金",           
    "women_in_tech": "科技界女性领袖奖",           
    "academic_excellence": "齐尼思学术卓越奖",           
    "entrepreneurship_desc": "授予有抱负和经验丰富的企业家提供学费资助的奖学金。",           
    "sustainability_desc": "授予那些致力于改善社区福祉或世界状况的人。",           
    "women_in_tech_desc": "授予具有杰出领导力的积极技术专业人士和高管。",           
    "academic_excellence_desc": "授予在整个学习过程中表现优异的学员。",           
    "emerging_leaders_desc": "授予在新兴行业或国家工作并具有较强领导能力的学员。",           
    "innovation_sponsorship_award": "创新赞助奖",
    "edcor_award": "Edcor 奖",
    "global_health_impact_network": "全球健康影响网络",
    "employer_partner": "雇主伙伴奖学金",
    "recruitment": "招聘奖学金",
    "strada": "领袖奖学金",
    "impact_quantic": "量化影响奖学金",
    "powell": "区域奖学金",
    "impact_valar": "Valar 影响奖学金",
    "hyperion": "区域奖学金",
    "base_scholarship": "奖学金",
    "strada_application": "领袖奖学金",
    "impact_quantic_application": "影响奖学金",
    "powell_application": "助学金",
    "impact_valar_application": "影响奖学金",
    "employer_partner_application": "雇主伙伴奖学金",
    "recruitment_application": "招聘奖学金",
    "hyperion_application": "助学金",
    "exec_ed_launch": "执行教育启动奖学金",
    "alumni_application": "校友奖学金",
    "zenith": "领导力奖学金",
    "zenith_application": "领导力奖学金",
    "alumni_quantic_launch": "首届队列奖学金",
    "apex_quantic": "Quantic 2025 Apex 奖学金",
    "apex_valar": "Valar 2025 Apex 奖学金",
    "ai_launch_2026": "2026年人工智能启动奖学金",
    "nexus_2025": "2025年Nexus奖学金",
    "alumni": "{{offeredYear}}校友奖学金",
    "regional_application": "区域奖学金"
}
};